




















import { Component, Mixins } from "vue-property-decorator";
import { ImageDrawableObjectMixin, StyledDrawableMixin } from "./mixins";
import { StampItem } from "../../../../domain/document/items";
import { ImageSourceKinds } from "../../../../domain/document";
import { DomainRegistry } from "../../../../domain";
import { User } from "../../../../domain/user";

@Component
export default class StampObject extends Mixins(ImageDrawableObjectMixin, StyledDrawableMixin) {
  editingSource: StampItem;

  data(): any {
    return {
      imgWidth: null,
      imgHeight: null,
    };
  }
  imgWidth: string;
  imgHeight: string;

  updated() {
    if (!this.editingSource.imageSource || this.editingSource.imageSource.imageSourceKind === ImageSourceKinds.None) {
      this.imgWidth = null;
      this.imgHeight = null;
    }
  }

  get displayName(): string {
    return this.editingSource.name;
  }

  get hasImage(): boolean {
    return !!this.imageSource;
  }
  
  get maxSizeStyleProperties(): any {
    return {
      maxWidth: this.size.width + "px",
      maxHeight: this.size.height + "px",
    };
  }

  adjustImageSizeWithRetry(): void {
    this.adjustImageSize();
    this.$nextTick(() => {
      // containerのサイズを正常に取得できていないことがあるので再度設定する
      this.adjustImageSize();
    });
  }

  adjustImageSize(): void {
    const image = this.$refs.image as HTMLImageElement;
    if (!image) { return; }

    const container = this.$refs.container as HTMLElement;
    const rect = container.getBoundingClientRect();
    const ratioWidth = image.naturalWidth / (rect.width > 0 ? rect.width : 1);
    const ratioHeight = image.naturalHeight / (rect.height > 0 ? rect.height : 1);

    // 比率が大きい方に合わせ、containerにフィットさせる
    this.imgWidth = (ratioWidth >= ratioHeight) ? "100%" : null;
    this.imgHeight = (ratioWidth <= ratioHeight) ? "100%" : null;
  }

  async applyStamp(): Promise<void> {
    this.emitFocus();

    const user = this.$store.getters.user as User;
    // 移行処理を修正前に移行したデータではisStamped=falseなのに押印があるデータがあり得る
    if (!this.editingSource.isStamped && !this.editingSource.hasImage) {
      await this.setUserStamp(user);
      return;
    }
    // すでに印影がある場合は同じ職員であればクリア可能
    // 移行処理を修正前に移行したデータではstampUserCodeも空になっているのでクリアできないことになるが、
    // クリアできてしまうよりはできないほうが安全のため、そのような案件が出てから対応を検討する
    if (!this.editingSource.stampUserCode) {
      this.$warn("印影", "ユーザ情報のない印影が押されているためクリアはできません。");
      return;
    }
    if (this.editingSource.stampUserCode.toUpperCase() !== user.id.toUpperCase()) {
      this.$warn("印影", "他のユーザの印影が押されているためクリアはできません。");
      return;
    }
    const isClearConfirmed = await this.isStampClearConfirmed();
    if (!isClearConfirmed) { return; }

    this.writeProperty((s: StampItem) => {
      s.clearStamp();
    });
  }

  private async isStampClearConfirmed(): Promise<boolean> {
    const result = await this.$commonDialogs.confirmation.confirmCancel("印影", ["印影をクリアしてもよろしいですか？"], "はい");
    return (result === 0);
  }

  private async setUserStamp(user: User): Promise<void> {
    const repo = DomainRegistry.document.getDocumentRepository();
    const imageSource = await repo.getUserStampImageSource(user.id);
    if (!imageSource) {
      this.$warn("印影", "印影が登録されていません。");
      return;
    }
    this.writeProperty((s: StampItem) => {
      s.imageSource = imageSource;
      s.stampUserCode = user.id;
      s.isStamped = true;
    });
  }
}
